export default __webpack_public_path__ + "static/thumb-landscape-2edefedb4440893150c8f072a5cae8b3.jpg";